module.exports = __webpack_public_path__ + "static/img/join_15.28343a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/join_15.png
// module id = ukM7
// module chunks = 0